import React from "react";
import { GridColDef } from "@mui/x-data-grid-pro";
import { numberType, dateTimeType } from "src/utils/dataGridFormat";
import useInventoryTransactions from "src/hooks/context/useInventoryTransactions";
import Modal from "src/components/Modal/Modal";
import DataGrid from "./DataGrid";
import InventoryTransactionsSummary from "../../Shared/InventoryTransactionsSummary";

const columns: GridColDef[] = [
  { field: "id", headerName: "Id" },
  { field: "locationId", headerName: "Location" },
  { field: "timestamp", headerName: "Created", ...dateTimeType, minWidth: 170, flex: 0.20 },
  { field: "transactionType", headerName: "Type", minWidth: 170, flex: 0.20 },
  { field: "operationType", headerName: "Operation" },
  { field: "status", headerName: "Status" },
  { field: "quantity", headerName: "Qty", ...numberType, minWidth: 50, flex: 0.1 },
  { field: "createdByUserId", headerName: "User Id", minWidth: 70, flex: 0.20 },
  { field: "externalItemIdentifier", headerName: "Identifier", minWidth: 140, flex: 0.16 },
  { field: "channel", headerName: "Channel", minWidth: 275, flex: 0.30 },
];

type InventoryTransactionsProps = {
  sku: string;
  locationId: number;
  isOpen: boolean;
  onClose: () => void;
};

const InventoryTransactionsModal: React.FC<InventoryTransactionsProps> = ({
  sku,
  locationId,
  isOpen,
  onClose,
}: InventoryTransactionsProps) => {
  const { isLoading, data } = useInventoryTransactions(sku, locationId, true);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal title="Transactions" isOpen={isOpen} primaryButtonName="Ok" onPrimaryButtonClick={onClose}>
      <InventoryTransactionsSummary data={data} isLoading={isLoading} />
      <span style={{ fontWeight: 700, marginTop: "24px", marginBottom: "8px", display: "block" }}>
        All active transactions
      </span>
      <DataGrid
        rows={data?.activeTransactions ?? []}
        columns={columns}
        isLoading={isLoading}
        containerWidth="100%"
        containerHeight="65vh"
        columnVisibilityModel={{
          id: false,
          locationId: false,
          operationType: false,
          status: false,
        }}
        hideFooter
      />
    </Modal>
  );
};

export default InventoryTransactionsModal;
